import { Redirect, useGlobalSearchParams } from 'expo-router'
import { UpdatePropertyView } from '~/components/assets/UpdatePropertyView'
import ScreenView from '~/components/layout/ScreenView'
import { LoadingView } from '~/components/LoadingView'
import { useAsset } from '~/data/assets/useAssets'

export default function PropertyEdit() {
  return (
    <ScreenView>
      <PropertyEditContent />
    </ScreenView>
  )
}

function PropertyEditContent() {
  const { assetId } = useGlobalSearchParams<{ assetId: string }>()
  const { asset, isLoading } = useAsset(assetId)

  if (isLoading) {
    return <LoadingView />
  }

  if (!asset) {
    return <Redirect href="/(authenticated)" />
  }

  return <UpdatePropertyView asset={asset} />
}
